import { doPost } from "./common";
interface Response {
  message: string;
  profile: {};
  refresh_token: string;
  session: string;
}
interface Params {
  email?: string;
  password?: string;
  facebook_token?: string;
  apple_token?: string;
  apple_client_id?: string;
  google_token?: string;
  google_client_id?: string;
  google_email?: string;
}

async function loginApi(
  email: string,
  password: string,
  gCaptcha: string,
  facebook_token: string,
  apple_token?: string,
  google_token?: string,
  google_email?: string
) {
  let body;
  if (facebook_token) {
    body = {
      facebook_token
    }
  } else if(apple_token) {
    body = {
      apple_token: apple_token,
      apple_client_id: 'com.elsaspeak.speechanalyzer'
    }
  } else if(google_token) {
    body = {
      google_token,
      google_client_id: '111373558431945137776'
    }
    if (google_email) {
      body = {
        ...body,
        email: google_email
      };
    }
  } else {
    body = {
      email,
      password
    }
  }
  const loginURL = (document.getElementById('login_url') as HTMLInputElement)?.value;
  return doPost<Response, Params>(
    loginURL,
    body,
    {
      'Content-Type': 'application/json'
    }
  );
}

export default loginApi;
